"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CaseAssessmentFormIMSchema = exports.CaseAssessmentFormSchema = exports.BaseCaseAssessmentFormSchema = void 0;
const zod_1 = require("zod");
const case_1 = require("./case");
const storage_object_1 = require("./storage-object");
const disclosure_1 = require("./disclosure");
const case_enums_1 = require("../enums/case-enums");
exports.BaseCaseAssessmentFormSchema = zod_1.z.object({
    id: zod_1.z.string(),
    submissionId: zod_1.z.string(),
    formId: zod_1.z.string(),
    caseId: zod_1.z.string(),
    formType: zod_1.z.nativeEnum(case_enums_1.CaseForm),
    createdAt: zod_1.z.date(),
    updatedAt: zod_1.z.date(),
    score: disclosure_1.scoringSchema,
    storageObjectVersionId: zod_1.z.string().nullish(),
});
exports.CaseAssessmentFormSchema = zod_1.z.lazy(() => exports.BaseCaseAssessmentFormSchema.extend({
    case: zod_1.z.lazy(() => case_1.BaseCaseSchema),
    storageObjectVersion: zod_1.z
        .lazy(() => storage_object_1.StorageObjectVersionBaseSchema)
        .nullish(),
}));
exports.CaseAssessmentFormIMSchema = zod_1.z.lazy(() => exports.BaseCaseAssessmentFormSchema.omit({
    id: true,
    createdAt: true,
    updatedAt: true,
}));
